export default "__VITE_ASSET__ee0ae263__"